/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Tag = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <g clipPath="url(#clip0_8658_2539)">
                        <path
                            d="M12.33 11.09L12.07 11C11.68 10.86 11.19 10.7 11.03 10.44C10.93 10.29 10.98 10.01 11.12 9.87C11.31 9.68 11.66 9.57 11.99 9.59C12.89 9.64 13.05 10.24 13.08 10.45L14.49 9.99C14.3 9.24 13.74 8.51 12.79 8.23V7H11.29V8.17C10.82 8.27 10.39 8.48 10.07 8.81C9.42999 9.45 9.3 10.49 9.77 11.24C10.21 11.95 11.01 12.22 11.6 12.42L11.85 12.51C12.55 12.76 13.05 12.96 13.19 13.41C13.27 13.65 13.22 13.91 13.05 14.13C12.82 14.43 12.43 14.58 11.98 14.56C11.41 14.52 10.94 14.3 10.36 13.32L10.3 13.22L8.92999 13.85L9.06999 14.08C9.50999 14.82 10.16 15.67 11.29 15.96V17H12.79V15.97C13.37 15.83 13.89 15.51 14.25 15.04C14.72 14.42 14.86 13.62 14.62 12.94C14.27 11.77 13.12 11.36 12.35 11.09H12.33Z"
                            fill={color}
                        />
                        <path
                            d="M11.97 22.96L2.05 13.04C1.78 12.77 1.63 12.4 1.63 12.01C1.63 11.62 1.78 11.26 2.05 10.98L10.62 2.40999C10.89 2.13999 11.26 1.98999 11.65 1.98999H20.56C21.36 1.98999 22.01 2.63999 22.01 3.43999V12.35C22.01 12.74 21.86 13.1 21.59 13.37L14.55 20.41L13.49 19.35L20.53 12.31V3.43999L11.66 3.48999L3.13 12.04L13.05 21.89L11.99 22.95L11.97 22.96Z"
                            fill={color}
                        />
                        <path
                            d="M17.5 8C18.3284 8 19 7.32843 19 6.5C19 5.67157 18.3284 5 17.5 5C16.6716 5 16 5.67157 16 6.5C16 7.32843 16.6716 8 17.5 8Z"
                            fill={color}
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_8658_2539">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
        );
    };
